var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "fade", appear: "" } }, [
    _c("div", { class: ["alert-container", _vm.type] }, [
      _c("div", { staticClass: "alert-text-container" }, [
        _c("span", { class: [_vm.icon, "alert-icon"] }),
        _c("span", {
          staticClass: "alert-text",
          domProps: { innerHTML: _vm._s(_vm.message) },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }